import router from '@/router';
import { State } from '@/studio/eventIntegration/store/types';
import { FieldMappingBooleans } from '@/studio/orgIntegration/store/types';
export default {
  isEventMapping(): boolean {
    const path = router?.currentRoute?.value.path?.toLowerCase();
    return path.startsWith('/event') || path.startsWith('/webinar');
  },
  areThereEventFieldMappingError(state: State, _, rootState): FieldMappingBooleans {
    const crmObjectTypes = rootState?.orgIntegration?.crmObjectTypes;
    const areThereFieldMappingError = {};
    crmObjectTypes.forEach(({ crm_object_type }) => {
      areThereFieldMappingError[crm_object_type] = state.eventFieldMappingRowError[crm_object_type].some(
        rowError => rowError !== null
      );
    });
    return areThereFieldMappingError;
  },
  areThereInvalidEventFieldMapping(state: State, _, rootState): FieldMappingBooleans {
    const crmObjectTypes = rootState?.orgIntegration?.crmObjectTypes;
    const areThereInvalidFieldMapping = {};
    crmObjectTypes.forEach(({ crm_object_type }) => {
      areThereInvalidFieldMapping[crm_object_type] =
        state.eventFieldMappingRowError?.[crm_object_type]?.some(
          rowError =>
            rowError && (rowError.code === 'MISSING_TARGET_FIELD' || rowError.code === 'MISSING_EVENT_SOURCE_FIELD')
        ) || false;
    });
    return areThereInvalidFieldMapping;
  },
  areThereEventFieldMappingChanges(state: State, _, rootState): FieldMappingBooleans {
    const crmObjectTypes = rootState?.orgIntegration?.crmObjectTypes;
    const areThereFieldMappingChanges = {};
    crmObjectTypes.forEach(({ crm_object_type }) => {
      if (
        state.eventFieldMappings[crm_object_type].mappings.length !==
        state.prevEventFieldMappings[crm_object_type].length
      ) {
        areThereFieldMappingChanges[crm_object_type] = true;
        return;
      }
      areThereFieldMappingChanges[crm_object_type] = state.eventFieldMappings[crm_object_type].mappings.some(
        (fieldMapping, index) =>
          JSON.stringify(fieldMapping) !== JSON.stringify(state.prevEventFieldMappings[crm_object_type][index])
      );
    });
    return areThereFieldMappingChanges;
  }
};
